export const contentMarketingFaqs = [
  {
    question: "What does content marketing include?",
    answer:
      "A content marketing scope can include audience and topic research, a practical content plan, website copy, articles, case studies, campaign landing pages, email content, social adaptations and reporting. The mix is agreed around one commercial goal rather than a promise to publish everywhere.",
  },
  {
    question: "How is content marketing different from copywriting?",
    answer:
      "Copywriting is the creation or improvement of individual pieces of copy. Content marketing also covers the audience, topic priorities, publishing rhythm, distribution, internal links and measurement needed to make those pieces work together over time.",
  },
  {
    question: "How does content marketing support SEO?",
    answer:
      "Useful content can answer relevant customer questions, strengthen priority service topics and create clearer internal paths through the website. Search demand is one source of evidence, but content is planned for the buyer and commercial journey rather than written only to repeat keywords.",
  },
  {
    question: "Can you turn our existing expertise into content?",
    answer:
      "Yes. Interviews, project notes, presentations, customer questions and existing sales material can provide useful source material. We agree who supplies facts, who approves them and how specialist or regulated claims will be checked before publication.",
  },
  {
    question: "Do you create images, photography and video?",
    answer:
      "Design adaptations can be included where agreed. Original photography, filming, on-site content capture, animation and substantial editing are separately scoped so production time, usage permissions and deliverables remain clear.",
  },
  {
    question: "How often should an Essex business publish content?",
    answer:
      "The right rhythm depends on the available expertise, approval capacity, customer journey and distribution plan. A smaller number of useful, well-supported pieces is often more valuable than a high-volume schedule the business cannot sustain or promote.",
  },
  {
    question: "How do you measure content marketing?",
    answer:
      "Measurement is connected to the job each piece needs to do. Depending on the scope, that can include relevant search visibility, engaged visits, service-page journeys, email response, assisted enquiries, qualified leads and what the evidence suggests should be improved next.",
  },
  {
    question: "How much does content marketing cost?",
    answer:
      "Investment depends on the research, number and depth of deliverables, subject-matter access, design or production needs, approval process and distribution support. We confirm a defined scope after reviewing the goal, evidence and internal capacity rather than presenting an unlimited content retainer.",
  },
]
